import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.95);
  color: white;
  padding: 20px;
  z-index: 1000;
  display: ${props => props.show ? 'block' : 'none'};
  font-family: 'League Spartan', sans-serif;
`;

const BannerContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const BannerText = styled.div`
  flex: 1;
  
  h3 {
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: 600;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    opacity: 0.9;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-family: 'League Spartan', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.accept {
    background: #ba3b3b;
    color: white;
    
    &:hover {
      background: #a03333;
    }
  }
  
  &.reject {
    background: transparent;
    color: white;
    border: 1px solid #666;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`;

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Verificar se o usuário já aceitou os cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <BannerContainer show={showBanner}>
      <BannerContent>
        <BannerText>
          <h3>🍪 Política de Cookies</h3>
          <p>
            Utilizamos cookies para melhorar sua experiência no site, 
            analisar o tráfego e personalizar conteúdo. 
            Ao continuar navegando, você concorda com nossa política de privacidade.
          </p>
        </BannerText>
        <ButtonGroup>
          <Button className="reject" onClick={rejectCookies}>
            Rejeitar
          </Button>
          <Button className="accept" onClick={acceptCookies}>
            Aceitar
          </Button>
        </ButtonGroup>
      </BannerContent>
    </BannerContainer>
  );
};

export default CookieBanner;
